import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';
import './SeleccionarPerfil.css';
import { getUserFromStorage, savePerfilToStorage } from '../services/auth';
import PinModal from '../components/PinModal';

function SeleccionarPerfil() {
  const [user, setUser] = useState(null);
  const [perfiles, setPerfiles] = useState([]);
  const [error, setError] = useState(null);
  const [mostrarFormularioAdmin, setMostrarFormularioAdmin] = useState(false);
  const [nombrePerfil, setNombrePerfil] = useState('');
  const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);
  const [cargando, setCargando] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (!storedUser) {
      navigate('/');
    } else {
      setUser(storedUser);
      cargarPerfiles(storedUser.id);
    }
  }, [navigate]);

  const cargarPerfiles = async (userId) => {
    try {
      setCargando(true);
      const res = await api.get(`/perfiles/${userId}`);
      
      if (res.data.length === 0 && !user?.isadmin) {
        setMostrarFormularioAdmin(true);
        return;
      }
      
      setPerfiles(res.data);
      setError(null);
      
      // Si viene de crear perfil y solo hay uno, seleccionarlo automáticamente
      if (location.state?.from === 'crear-perfil' && res.data.length === 1) {
        seleccionarPerfil(res.data[0]);
      }
    } catch (error) {
      console.error('Error al cargar perfiles:', error);
      setError('Error al cargar perfiles. Intenta recargar la página.');
    } finally {
      setCargando(false);
    }
  };

  const crearPerfilAdmin = async () => {
    if (!nombrePerfil.trim()) {
      setError('Debes ingresar un nombre para el perfil');
      return;
    }

    try {
      setCargando(true);
      const res = await api.post('/perfiles/crear-admin', {
        userId: user.id,
        nombre: nombrePerfil
      });

      navigate(`/crear-pin/${res.data.perfil.id}`, {
        state: { from: 'crear-admin' }
      });
    } catch (err) {
      console.error('Error creando perfil admin:', err);
      setError(err.response?.data?.message || 'Error al crear perfil administrador');
    } finally {
      setCargando(false);
    }
  };

  const seleccionarPerfil = (perfil) => {
    const perfilData = {
      id: perfil.id,
      nombre: perfil.nombre,
      es_admin: perfil.es_admin,
      avatar: perfil.avatar,
      pin: perfil.pin,
      user_id: perfil.user_id || user?.id  // Prioriza user_id del perfil, si no usa el del usuario
    };
  
    if (perfil.pin && perfil.pin.length >= 4) {
      setPerfilSeleccionado(perfilData);
    } else {
      guardarPerfilYRedirigir(perfilData);
    }
  };

  

  const guardarPerfilYRedirigir = (perfil) => {
    // Asegúrate de incluir el user_id del usuario actual
    const perfilCompleto = {
      ...perfil,
      user_id: user?.id || perfil.user_id // Prioriza el user_id del usuario actual
    };
  
    const ok = savePerfilToStorage(perfilCompleto, user?.id);
    
    if (!ok) {
      console.error('❌ Error al guardar el perfil');
      return;
    }
  
    navigate('/dashboard', { 
      state: { 
        perfil: perfilCompleto,
        from: 'seleccionar-perfil'
      } 
    });
  };

  

  const confirmarPinCorrecto = (perfil) => {
    guardarPerfilYRedirigir(perfil);
    setPerfilSeleccionado(null);
  };

  const cancelarPin = () => {
    setPerfilSeleccionado(null);
  };

  const cerrarSesion = () => {
    localStorage.removeItem('perfilActual');
    localStorage.removeItem('perfilActivoId');
    localStorage.removeItem('user');
    navigate('/');
  };

  if (cargando) {
    return (
      <div className="cargando-container">
        <div className="cargando-spinner"></div>
        <p>Cargando perfiles...</p>
      </div>
    );
  }

  if (mostrarFormularioAdmin) {
    return (
      <div className="formulario-admin-container">
        <div className="formulario-admin">
          <h2>Crear Perfil Administrador</h2>
          <p>Como es tu primera vez, necesitas crear un perfil administrador.</p>
          <p>Este perfil podrá gestionar otros perfiles y configuraciones.</p>

          <div className="input-group">
            <label>Nombre del perfil:</label>
            <input 
              type="text" 
              value={nombrePerfil}
              onChange={(e) => setNombrePerfil(e.target.value)}
              placeholder="Ej: Administrador"
              disabled={cargando}
            />
          </div>

          <button 
            onClick={crearPerfilAdmin}
            disabled={cargando}
          >
            {cargando ? 'Creando...' : 'Crear Perfil'}
          </button>
          
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="seleccionar-perfil-container">
      <div className="selector-perfiles">
        <h2>Selecciona un perfil</h2>
        
        {error && (
          <div className="error-banner">
            {error}
            <button onClick={() => setError(null)}>×</button>
          </div>
        )}

        {perfiles.length === 0 ? (
          <div className="sin-perfiles">
            <p>No hay perfiles disponibles</p>
            {user?.isadmin && (
              <button 
                onClick={() => navigate('/crear-perfil')}
                className="btn-crear-perfil"
              >
                Crear nuevo perfil
              </button>
            )}
          </div>
        ) : (
          <div className="grid-perfiles">
            {perfiles.map(perfil => (
              <div 
                key={perfil.id} 
                className={`card-perfil ${perfil.es_admin ? 'admin' : ''}`}
                onClick={() => seleccionarPerfil(perfil)}
              >
                <div className="avatar-container">
                  <img
  src={`${import.meta.env.VITE_API_URL || 'https://mundiemby.us.to'}/avatars/${perfil.avatar || 'default.png'}`}
  alt={perfil.nombre}
  className="avatar-perfil"
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = '/default-avatar.png';
  }}
/>
                  {perfil.pin && <span className="icono-candado">🔒</span>}
                </div>
                <div className="perfil-info">
                  <span className="perfil-nombre">{perfil.nombre}</span>
                  {perfil.es_admin && <span className="badge-admin">Admin</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        <button 
          onClick={cerrarSesion} 
          className="btn-cerrar-sesion"
        >
          Cerrar sesión
        </button>
      </div>

      {perfilSeleccionado && (
        <PinModal
          perfil={perfilSeleccionado}
          onConfirm={confirmarPinCorrecto}
          onCancel={cancelarPin}
        />
      )}
    </div>
  );
}

export default SeleccionarPerfil;